/* Brunelia : search (instant search window #rv-search and results page /search), loaded after rv-core.js.
   Shopify's own search (semantic + typo tolerant) returns « Mars », « Marrakech », « Martinique » for « marseille ».
   Here the ranking comes from our own index of the posters (templates/collection.rv-index.liquid, 6 x 250 posters,
   kept 6 h in localStorage per language and currency):
   1. posters whose title (or collection, or theme) holds the searched words as whole words (« chat » never gives « château »),
      plurals and accents folded, a typo fixed against the real words of the catalogue (« marseile » gives « marseille »);
   2. then « close » posters, like the packs: posters sharing the most specific collections with the first ones
      (Marseille gives Cassis, La Ciotat, Provence), never the whole catalogue;
   3. a collection whose name is the query comes first (« Vous cherchiez la collection Marseille »).
   Shopify's predictive search stays the fallback (index unreachable, or no poster holds the words) and serves the articles.
   Scopes Affiches / Collections / Articles on the /search page. Markup: .rvs-* classes only, easy to restyle.
   Search window (21/10, design A, job fenetre-recherche): cream drawer from the top (snippets/rv-overlays.liquid, .rsx-* classes),
   recent searches kept on this device, collection first, posters as real posters with their short name, arrow keys.
   Every language of the markets (fr de en it es nl pt da sv fi pl cs): stop words, « Küchenposter » split into « küchen »,
   and the search words of each collection in 12 languages (assets/rv-search-alias.js, from scripts/recherche/synonymes.json):
   « küche » on .de, « keuken » on .nl, « kitchen » on .fr all give the kitchen collection first. */
(function (root) {
  "use strict";

  /* ======================= Engine (no DOM, also runs under node for the measures) ======================= */
  var STOP_LIST = "affiche affiches poster posters print prints illustration illustrations illustree illustrees tableau tableaux " +
    "de du des la le les l d et a au aux en un une sur sous dans pour par avec ou " +
    "the of and in on at an to for with from or vintage retro " +
    /* other languages of the markets: « poster » words and small words (never a word that is also a search, like « bad ») */
    "plakat plakate bild bilder druck drucke kunstdruck kunstdrucke wandbild wandbilder der die das den dem und mit fur von im zum zur ein eine " +
    "stampa stampe manifesto manifesti quadro quadri il lo gli i e di da per con del della dei delle " +
    "lamina laminas cuadro cuadros cartel carteles el los las y con para del " +
    "affisch affischer juliste julisteet plakaty plakatu plakaty plakáty obraz obrazy het een van voor met og med til af och för ja w z na do se ve pro";
  var SUFFIX = ["eur", "eurs", "euse", "euses", "ier", "iers", "iere", "ieres", "ing", "ois", "oise", "oises", "ais", "aise", "aises", "ien", "ienne", "iennes",
    /* German, Dutch plurals and forms: « berg » finds « berge », « blume » finds « blumen » */
    "e", "en", "n", "er", "es"];
  /* « Küchenposter », « Bergplakat », « köksaffisch »: the poster word glued at the end of the place or theme */
  var GLUED = ["posters", "poster", "plakate", "plakaten", "plakat", "plakaty", "plakaat", "affischer", "affisch", "julisteet", "juliste"];

  function norm(s) {
    return String(s == null ? "" : s).toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "")
      .replace(/œ/g, "oe").replace(/æ/g, "ae").replace(/ß/g, "ss").replace(/[^a-z0-9]+/g, " ").trim();
  }
  function fold(w) {
    if (w.length > 4 && /eaux$/.test(w)) return w.slice(0, -1);
    if (w.length > 4 && /aux$/.test(w)) return w.slice(0, -3) + "al";
    if (w.length > 3 && /[sx]$/.test(w) && !/ss$/.test(w)) return w.slice(0, -1);
    return w;
  }
  function unglue(w) {
    for (var i = 0; i < GLUED.length; i++) {
      var g = GLUED[i];
      if (w.length - g.length >= 3 && w.slice(-g.length) === g) return w.slice(0, -g.length);
    }
    return w;
  }
  function toks(s) { var n = norm(s); return n ? n.split(" ").map(function (w) { return fold(unglue(w)); }) : []; }
  var STOP = {}; toks(STOP_LIST).forEach(function (w) { STOP[w] = 1; });
  function lev(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var prev = [], cur, i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      cur = [i]; var lo = i;
      for (j = 1; j <= b.length; j++) { cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1)); if (cur[j] < lo) lo = cur[j]; }
      if (lo > max) return max + 1;
      prev = cur;
    }
    return prev[b.length];
  }
  /* derived word: « paris » finds « parisienne », « ski » finds « skieur », « chat » never finds « château » */
  function derived(tok, w) {
    if (tok.length <= w.length || tok.indexOf(w) !== 0) return false;
    var rest = tok.slice(w.length);
    if (w.length >= 5 && rest.length <= 5) return true;
    return SUFFIX.indexOf(rest) > -1;
  }

  function Engine(products, cols) {
    var N = products.length || 1, size = {}, byId = {}, vocab = {};
    var add = function (set, list) { list.forEach(function (w) { set[w] = 1; vocab[w] = (vocab[w] || 0) + 1; }); };
    var keyOf = function (t) { var all = toks(t), k = all.filter(function (w) { return !STOP[w]; }); return (k.length ? k : all).join(" "); };
    /* search words of the collection in 12 languages: the whole query must be one of them (« keuken », « salle de bain ») */
    var alias = {};
    cols.forEach(function (c) {
      c.toks = toks(c.t); c.key = keyOf(c.t); byId[c.i] = c;
      (c.al || []).forEach(function (a) { var k = keyOf(a); if (k) (alias[k] = alias[k] || []).push(c); });
    });
    products.forEach(function (p, r) {
      p.r = r; p.tt = toks(p.t); p.ts = {}; p.ct = {}; p.mt = {}; p.c = p.c || [];
      add(p.ts, p.tt);
      p.c.forEach(function (id) { size[id] = (size[id] || 0) + 1; if (byId[id]) add(p.ct, byId[id].toks); });
      if (p.m) add(p.mt, toks(String(p.m).replace(/\|/g, " ")));
      p.line = " " + p.tt.join(" ") + " ";
    });
    cols.forEach(function (c) { c.size = size[c.i] || 0; });
    var vlist = Object.keys(vocab);

    function wscore(p, w, prefix) {
      if (p.ts[w]) return 10;
      if (p.ct[w]) return 7;
      if (p.mt[w]) return 4;
      var i, t = p.tt;
      for (i = 0; i < t.length; i++) if (derived(t[i], w)) return 6;
      for (var d in p.ct) if (derived(d, w)) return 5;
      if (prefix) for (i = 0; i < t.length; i++) if (t[i].indexOf(w) === 0) return 5;
      if (prefix) for (var k in p.ct) if (k.indexOf(w) === 0) return 4;
      return 0;
    }
    function othersStart(w, c) {
      for (var i = 0; i < vlist.length; i++) if (vlist[i] !== w && vlist[i].indexOf(w) === 0 && c.toks.indexOf(vlist[i]) < 0) return true;
      return false;
    }
    function knownPrefix(w) { if (w.length < 2) return false; for (var i = 0; i < vlist.length; i++) if (vlist[i].indexOf(w) === 0) return true; return false; }
    function fuzzy(w) {
      var max = w.length >= 8 ? 2 : w.length >= 5 ? 1 : 0; if (!max) return null;
      var best = null, bd = max + 1, bf = 0;
      vlist.forEach(function (v) { var d = lev(w, v, max); if (d < bd || (d === bd && vocab[v] > bf)) { bd = d; best = v; bf = vocab[v]; } });
      return bd <= max ? best : null;
    }
    function colMatch(c, words) {
      return words.every(function (w) { return c.toks.some(function (t) { return t === w || derived(t, w); }); });
    }

    /* opt.live: the visitor is still typing (last word may be the start of a word) */
    function search(q, opt) {
      opt = opt || {};
      var raw = toks(q), words = raw.filter(function (w) { return !STOP[w]; });
      if (!words.length) words = raw;
      if (!words.length) return null;
      var last = words.length - 1, typed = norm(q).split(" ").pop().length;
      /* a search word of a collection in any language: that collection first, all its posters found */
      var al = alias[words.join(" ")], byAlias = null;
      if (al) al.forEach(function (c) { if (c.size && (!byAlias || c.size > byAlias.size)) byAlias = c; });
      /* still typing a short word (« mar » for Marseille, Spanish « mar » is the sea): only when nothing else starts with it */
      if (byAlias && opt.live && typed <= 3 && othersStart(words[last], byAlias) &&
        !byAlias.toks.some(function (t) { return t.indexOf(words[last]) === 0; })) byAlias = null;
      /* start of a word: while typing, the last word (« mar » gives Marseille; « chat » is a whole word, never « château »);
         on the results page, a word the catalogue does not have as such */
      var prefixOk = function (i) {
        var w = words[i];
        if (opt.live && i === last) return w.length >= 2 && (vocab[w] ? typed <= 3 : knownPrefix(w));
        return !vocab[w] && w.length >= 3 && knownPrefix(w);
      };
      var fixed = byAlias ? words : words.map(function (w, i) { if (vocab[w] || prefixOk(i)) return w; return fuzzy(w) || w; });
      var corrected = fixed.join(" ") !== words.join(" ");
      words = fixed;
      var phrase = words.join(" ");
      var exact = null;
      cols.forEach(function (c) { if (c.size && c.key === phrase && (!exact || c.size > exact.size)) exact = c; });
      if (!exact && byAlias) exact = byAlias;
      var hits = [], partial = false;
      var run = function (need) {
        products.forEach(function (p) {
          var s = 0, m = 0;
          var inEx = byAlias && byAlias === exact && p.c.indexOf(exact.i) > -1;
          words.forEach(function (w, i) { var x = wscore(p, w, prefixOk(i)) || (inEx ? 7 : 0); if (x) { m++; s += x; } });
          if (m < need) return;
          if (words.length > 1 && p.line.indexOf(" " + phrase + " ") > -1) s += 5;
          if (exact && p.c.indexOf(exact.i) > -1) s += 8;
          if (p.k) s -= 3;
          if (p.a === 0) s -= 4;
          hits.push({ p: p, s: s + m * 20 });
        });
      };
      run(words.length);
      if (!hits.length && words.length > 1) { partial = true; run(Math.ceil(words.length / 2)); }
      hits.sort(function (a, b) { return b.s - a.s || a.p.r - b.p.r; });

      /* close posters (the packs logic): weight of a collection = share of the found posters in it x rarity of the collection */
      var near = [], nearCols = [];
      if (hits.length && hits.length < 24 && !opt.noNear) {
        var S = hits.slice(0, 24), seen = {}, freq = {}, colW = {};
        S.forEach(function (h) { seen[h.p.h] = 1; h.p.c.forEach(function (id) { freq[id] = (freq[id] || 0) + 1; }); });
        Object.keys(freq).forEach(function (id) {
          var sz = size[id], share = freq[id] / S.length;
          /* only collections that hold at least 60 % of the found posters: « chat » (a cat, cat-eye glasses, Le Chat Noir) gets no close posters */
          if (!sz || sz > N * 0.12 || !byId[id] || share < 0.6) return;
          colW[id] = share * Math.log(N / sz);
        });
        var cand = [], top = 0;
        products.forEach(function (p) {
          if (seen[p.h] || p.a === 0) return;
          var sc = 0; p.c.forEach(function (id) { if (colW[id]) sc += colW[id]; });
          if (sc > 0) { cand.push({ p: p, s: sc }); if (sc > top) top = sc; }
        });
        cand.sort(function (a, b) { return b.s - a.s || a.p.r - b.p.r; });
        var room = Math.max(8, 24 - hits.length);
        near = cand.filter(function (c) { return c.s >= top * 0.5; }).slice(0, room);
        /* collections to name above them (« Aussi en Provence, Côte d'Azur »): the heaviest ones that bring new posters */
        var bring = {};
        near.forEach(function (c) { c.p.c.forEach(function (id) { if (colW[id]) bring[id] = (bring[id] || 0) + 1; }); });
        nearCols = Object.keys(bring).filter(function (id) { return !exact || Number(id) !== exact.i; })
          .sort(function (a, b) { return colW[b] * bring[b] - colW[a] * bring[a]; }).slice(0, 2).map(function (id) { return byId[id]; });
      }
      var found = cols.filter(function (c) { return c.size && (c === exact || colMatch(c, words)); })
        .sort(function (a, b) { return (b === exact) - (a === exact) || b.size - a.size; });
      /* featured collection (« La collection d'abord »): the exact one, else the biggest collection whose name holds every word */
      var feat = exact || (found[0] && found[0].size >= 3 ? found[0] : null), featP = 0;
      if (feat) products.forEach(function (p) { if (p.a !== 0 && p.p > 0 && p.c.indexOf(feat.i) > -1 && (!featP || p.p < featP)) featP = p.p; });
      nearCols.forEach(function (c) { if (found.indexOf(c) < 0) found.push(c); });
      return { q: q, words: words, shown: words.join(" "), corrected: corrected, partial: partial, exact: exact, hits: hits, near: near, nearCols: nearCols, cols: found, feat: feat, featP: featP };
    }
    function textMatch(title, words) {
      var tt = toks(title);
      return words.every(function (w) { return tt.some(function (t) { return t === w || derived(t, w); }); });
    }
    return { search: search, textMatch: textMatch, size: N, alias: function (q) { var a = alias[keyOf(q)]; return a ? a[0] : null; } };
  }

  var API = { Engine: Engine, norm: norm, toks: toks };
  if (typeof module === "object" && module.exports) { module.exports = API; return; }
  root.RVSearch = API;

  /* ======================= Browser ======================= */
  var RV = root.RV || {}, doc = document;
  var $ = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); };
  var esc = RV.esc || function (s) { return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;"); };
  var T = function (k, v) { var s = RV.t ? RV.t("search_js." + k, v) : k; return s === "search_js." + k ? k : s; };
  var plural = function (n, w) { return RV.plural ? RV.plural(n, w) : n + " " + w; };
  var money = function (c) { return RV.money ? RV.money(c) : (c / 100).toFixed(2); };
  var searchUrl = RV.searchUrl || "/search";
  var sameRoot = (RV.root || "/").replace(/\/$/, "");
  var purl = function (p) { return p.u || sameRoot + "/products/" + p.h; };
  var img = function (p, w) { return p.i ? String(p.i).replace(/width=\d+/, "width=" + w) : ""; };

  /* ---------- index: collections from #rv-coll-index (every page), posters from the index template ---------- */
  var COLS = [];
  try { COLS = JSON.parse(($("#rv-coll-index") || {}).textContent || "[]").filter(function (c) { return c.i; }); } catch (e) {}
  var KEY = "rv-sx2:" + (RV.lang || "") + ":" + (RV.currency || "") + ":" + (RV.country || "");
  var TTL = 6 * 3600 * 1000, engineP = null;
  function fetchPage(n) {
    var u = sameRoot + "/collections/all?view=rv-index&sort_by=best-selling&page=" + n;
    return fetch(u, { credentials: "same-origin" }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  function loadIndex() {
    if (engineP) return engineP;
    engineP = new Promise(function (ok, ko) {
      var c = null;
      try { c = JSON.parse(localStorage.getItem(KEY) || "null"); } catch (e) {}
      if (c && c.at > Date.now() - TTL && c.p && c.p.length) return ok(c.p);
      fetchPage(1).then(function (first) {
        var rest = [];
        for (var i = 2; i <= Math.min(first.pages || 1, 20); i++) rest.push(fetchPage(i));
        return Promise.all(rest).then(function (pages) {
          var all = first.p.slice(); pages.forEach(function (pg) { all = all.concat(pg.p || []); });
          try { localStorage.setItem(KEY, JSON.stringify({ at: Date.now(), p: all })); } catch (e) {}
          ok(all);
        });
      }).catch(ko);
    }).then(function (p) {
      var AL = root.RV_ALIAS || {};
      return Engine(p, COLS.map(function (c) { return { i: c.i, h: c.h, t: c.t, u: c.u, n: c.n, al: AL[c.i] ? String(AL[c.i]).split(/\s*,\s*/) : [] }; }));
    });
    engineP.catch(function () { engineP = null; });
    return engineP;
  }
  function predictive(q, types, limit, signal) {
    var u = (RV.predictiveUrl || "/search/suggest") + ".json?q=" + encodeURIComponent(q) + "&resources[type]=" + types +
      "&resources[limit]=" + limit + "&resources[options][unavailable_products]=last";
    return fetch(u, signal ? { signal: signal } : {}).then(function (r) { return r.json(); }).then(function (j) { return (j.resources && j.resources.results) || {}; });
  }
  /* « 6 posters » with the right plural; collection link list; highlight of the searched words */
  function hl(title, words) {
    var parts = String(title).split(/(\s+|[-'’,.])/), out = "";
    parts.forEach(function (w) {
      var f = toks(w)[0];
      var on = f && words.some(function (q) { return f === q || (f.indexOf(q) === 0 && (q.length >= 3)); });
      out += on ? "<mark>" + esc(w) + "</mark>" : esc(w);
    });
    return out;
  }
  function allUrl(q) { return searchUrl + "?q=" + encodeURIComponent(q) + "&type=product&options%5Bprefix%5D=last"; }

  /* ======================= Shared bits (window and page) ======================= */
  /* noExact: the featured collection already says it (card in the window, hero on the page) */
  function banner(r, noExact) {
    if (r.exact && !noExact) return '<p class="rvs-exact didyou">' + T("exact_col", { link: '<a href="' + esc(r.exact.u) + '">' + esc(r.exact.t) + "</a>", count: esc(plural(r.exact.size, "affiche")) }) + "</p>";
    if (r.corrected) return '<p class="rvs-fixed didyou">' + T("fixed", { q: "<b>" + esc(r.shown) + "</b>" }) + "</p>";
    return "";
  }
  function colList(cols, words) {
    return cols.length ? '<ul class="sov-list rvs-cols">' + cols.slice(0, 12).map(function (c) {
      return '<li><a href="' + esc(c.u) + '"><span>' + hl(c.t, words) + "</span><small>" + esc(plural(c.size || c.n, "affiche")) + "</small></a></li>";
    }).join("") + "</ul>" : '<p class="rvs-empty">' + T("no_collection") + "</p>";
  }
  function artList(arts, words) {
    return arts.length ? '<ul class="sov-list rvs-arts">' + arts.slice(0, 6).map(function (a) {
      return '<li><a href="' + esc(a.url) + '"><span>' + hl(a.title, words) + "</span></a></li>";
    }).join("") + "</ul>" : '<p class="rvs-empty">' + T("no_article") + "</p>";
  }
  /* ---------- « La collection d'abord »: mood photo, wall photos and text of the featured collection (templates/collection.rv-feat) ---------- */
  var featCache = {};
  function featData(c) {
    if (!featCache[c.u]) {
      featCache[c.u] = fetch(c.u + (c.u.indexOf("?") > -1 ? "&" : "?") + "view=rv-feat", { credentials: "same-origin" })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .catch(function () { delete featCache[c.u]; return null; });
    }
    return featCache[c.u];
  }
  function plain(s) { var t = doc.createElement("textarea"); t.innerHTML = String(s || ""); return t.value; }
  /* nearby collections, shown like the packs: the ones the close posters come from, then the other collections holding the words */
  function nearChips(r, max) {
    var list = (r.nearCols || []).concat(r.cols || []).filter(function (c, i, a) { return c && c !== r.feat && c.size && a.indexOf(c) === i; }).slice(0, max);
    return list.length ? '<div class="rvs-chips"><span class="script">' + T("near") + "</span>" + list.map(function (c) {
      return '<a class="chip" href="' + esc(c.u) + '">' + esc(c.t) + " <small>" + c.size + "</small></a>";
    }).join("") + "</div>" : "";
  }
  function nearTitle(r) {
    var names = (r.nearCols || []).map(function (c) { return '<a href="' + esc(c.u) + '">' + esc(c.t) + "</a>"; });
    return names.length ? T("near_in", { names: names.join(", ") }) : T("near");
  }

  /* ======================= Search window (design A) ======================= */
  /* words of the window that the theme locales do not have, one language per site (the site's language, never a mix) */
  var WORDS = {
    fr: { sug: "Suggestions", mag: "Au Magazine", posters: "Affiches", all: "Tout voir", none: "Aucune affiche pour « {q} »", tip: "Essayez un lieu, une pièce ou un thème. Ou partez d'ici :", results: "Voir tous les résultats" },
    de: { sug: "Vorschläge", mag: "Im Magazin", posters: "Poster", all: "Alle ansehen", none: "Kein Poster für „{q}“", tip: "Probiere einen Ort, einen Raum oder ein Thema. Oder starte hier:", results: "Alle Ergebnisse ansehen" },
    it: { sug: "Suggerimenti", mag: "Dal Magazine", posters: "Poster", all: "Vedi tutti", none: "Nessun poster per «{q}»", tip: "Prova un luogo, una stanza o un tema. Oppure parti da qui:", results: "Vedi tutti i risultati" },
    es: { sug: "Sugerencias", mag: "En el Magazine", posters: "Láminas", all: "Ver todas", none: "Ninguna lámina para «{q}»", tip: "Prueba un lugar, una estancia o un tema. O empieza por aquí:", results: "Ver todos los resultados" },
    en: { sug: "Suggestions", mag: "From the Magazine", posters: "Posters", all: "See all", none: "No posters for “{q}”", tip: "Try a place, a room or a theme. Or start here:", results: "See all results" }
  };
  var LW = WORDS[(RV.lang || doc.documentElement.lang || "en").slice(0, 2)] || WORDS.en;
  var W = function (k, q) { return esc(LW[k]).replace("{q}", esc(q || "")); };
  var ov = $("#rv-search"), box = $("#rv-search-res"), input = $("#rv-search-in"), idle = box ? box.innerHTML : "";
  var status = $("#rv-search-st"), mfoot = $("[data-rsx-mfoot]");
  var timer = null, ctl = null, lastQ = "", seq = 0, logTimer = null, logged = "";
  var ICON_ARROW = '<svg width="16" height="16" aria-hidden="true"><use href="#i-arrow"/></svg>';

  /* short name of a poster: the printed title (index « n »), else the product title without « Affiche » / « poster » and the tail after a dash */
  function shortName(p) {
    var n = p.n || String(p.t || "").replace(/^(affiche|poster|plakat|print)\s+/i, "").replace(/\s+(poster|posters|print)$/i, "").split(/\s+[–—-]\s+|\s*:\s+/)[0];
    if (n === n.toUpperCase() && /[A-Z]/.test(n)) n = n.toLowerCase().replace(/(^|[\s'’-])(\S)/g, function (m, a, b) { return a + b.toUpperCase(); });
    n = n.charAt(0).toUpperCase() + n.slice(1);
    return n.length > 42 ? n.slice(0, 40).replace(/\s+\S*$/, "") + "…" : n;
  }
  function pcard(p, words) {
    var src = img(p, 300);
    return '<a class="rsx-pc" href="' + esc(purl(p)) + '"><span class="rsx-pw"><span class="rsx-poster">' +
      (src ? '<img src="' + esc(src) + '" alt="" loading="lazy" width="300" height="420">' : "") + "</span></span>" +
      "<b>" + hl(shortName(p), words || []) + "</b><small>" + (p.p ? T("from_price", { price: esc(money(p.p)) }) : "") + "</small></a>";
  }
  function ctile(c, words) {
    return '<a class="rsx-ct" href="' + esc(c.u) + '" data-rsx-ph="' + esc(c.u) + '"><span class="rsx-ph"></span><b>' + hl(c.t, words) + "</b><small>" + esc(plural(c.size, "affiche")) + "</small></a>";
  }
  function bigCard(r) {
    var c = r.feat;
    return '<a class="rsx-big" href="' + esc(c.u) + '" data-rsx-ph="' + esc(c.u) + '"><span class="rsx-ph"></span><span class="rsx-tx">' +
      '<span class="rsx-k">' + T("feat_kicker") + "</span><b>" + esc(c.t) + "</b>" +
      "<small>" + esc(plural(c.size, "affiche")) + (r.featP ? " · " + T("from_price", { price: esc(money(r.featP)) }) : "") + "</small>" +
      '<span class="rsx-btn">' + T("feat_cta_n", { count: esc(plural(c.size, "affiche")) }) + " " + ICON_ARROW + "</span></span></a>";
  }
  /* mood photos of the collection cards, as they arrive */
  function fillPhotos() {
    $$("[data-rsx-ph]", box).forEach(function (a) {
      var u = a.getAttribute("data-rsx-ph"); a.removeAttribute("data-rsx-ph");
      featData({ u: u }).then(function (d) {
        var ph = $(".rsx-ph", a);
        if (ph && d && d.i && !ph.firstChild) ph.innerHTML = '<img src="' + esc(d.i) + '" alt="" loading="lazy">';
      });
    });
  }
  /* the part of the empty state reused under « no result »: popular searches, rooms, most loved */
  function idlePart(sel) { var d = doc.createElement("div"); d.innerHTML = idle; var el = $(sel, d); return el ? el.outerHTML : ""; }
  function setFoot(html) { if (!mfoot) return; mfoot.innerHTML = html || ""; mfoot.hidden = !html; }
  function say(t) { if (status) status.textContent = t; }

  function renderWindow(q, r, arts, fallback) {
    if (!box) return;
    var words = r ? r.words : toks(q), hits = r ? r.hits.map(function (h) { return h.p; }) : [], near = r ? r.near.map(function (h) { return h.p; }) : [];
    if (fallback) { hits = fallback; near = []; }
    var list = hits.concat(near), np = list.length, cols = r ? r.cols : [], sq = r && r.corrected ? r.shown : String(q).trim();
    if (!np && !cols.length && !arts.length) {
      box.innerHTML = '<div class="rsx-body"><div class="rsx-side">' + idlePart("[data-rsx-pop]") + '</div><div class="rsx-main"><div class="rsx-none"><h3>' + W("none", q) + "</h3><p>" + W("tip") + "</p></div>" +
        idlePart("[data-rsx-rooms]") + idlePart("[data-rsx-best]") + "</div></div>";
      setFoot(""); say(LW.none.replace("{q}", q));
      return;
    }
    var feat = r && r.feat && np ? r.feat : null, others = cols.filter(function (c) { return c !== feat; });
    var side = (cols.length ? '<h3 class="rsx-lbl">' + W("sug") + '</h3><ul class="rsx-sug">' + cols.slice(0, 6).map(function (c) {
      return '<li><a href="' + esc(c.u) + '"><span>' + hl(c.t, words) + "</span><small>" + esc(plural(c.size || c.n, "affiche")) + "</small></a></li>";
    }).join("") + "</ul>" : "") +
      (arts.length ? '<h3 class="rsx-lbl rsx-mag">' + W("mag") + '</h3><ul class="rsx-arts">' + arts.slice(0, 3).map(function (a) {
        var im = a.image && (a.image.url || a.image) ? String(a.image.url || a.image) : "";
        return '<li><a href="' + esc(a.url) + '">' + (im ? '<img src="' + esc(im.indexOf("?") > -1 ? im + "&width=128" : im + "?width=128") + '" alt="" loading="lazy" width="64" height="44">' : "") + "<span>" + hl(a.title, words) + "</span></a></li>";
      }).join("") + "</ul>" : "");
    var main = (r ? banner(r, true) : "") +
      (r && r.partial ? '<p class="rsx-note">' + T("partial") + "</p>" : "") + (fallback ? '<p class="rsx-note">' + T("approx", { q: esc(q) }) + "</p>" : "");
    if (feat) main += '<div class="rsx-feat">' + bigCard(r) + others.slice(0, 2).map(function (c) { return ctile(c, words); }).join("") + "</div>";
    if (np) {
      main += '<h3 class="rsx-lbl">' + W("posters") + (np > 6 ? " <em>" + esc(plural(np, "affiche")) + "</em>" : "") + '<a href="' + esc(allUrl(sq)) + '">' + W("all") + " " + ICON_ARROW + "</a></h3>" +
        '<div class="rsx-row rsx-scroll">' + list.slice(0, 6).map(function (p) { return pcard(p, words); }).join("") + "</div>";
    } else if (cols.length) {
      main += '<div class="rsx-tiles rsx-scroll">' + cols.slice(0, 4).map(function (c) { return ctile(c, words); }).join("") + "</div>";
    }
    if (feat && r.nearCols && r.nearCols.length) main += nearChips(r, 4);
    var allLink = np ? T("see_all", { count: esc(plural(np, "affiche")), q: esc(sq) }) : W("results");
    main += '<div class="rsx-foot"><span>' + esc(plural(np, "affiche")) + (cols.length ? " · " + esc(plural(cols.length, "collection")) : "") +
      '</span><a href="' + esc(allUrl(sq)) + '">' + allLink + " " + ICON_ARROW + "</a></div>";
    box.innerHTML = '<div class="rsx-body">' + (side ? '<div class="rsx-side">' + side + "</div>" : "") + '<div class="rsx-main">' + main + "</div></div>";
    fillPhotos();
    setFoot(np ? '<a href="' + esc(allUrl(sq)) + '">' + allLink + "</a>" : "");
    say(np ? plural(np, "affiche") : LW.none.replace("{q}", q));
  }
  function showIdle() {
    lastQ = ""; seq++; if (ctl) ctl.abort();
    if (box) { box.innerHTML = idle; fillRecent(); }
    setFoot(""); say("");
  }
  function runWindow(q) {
    var my = ++seq;
    if (ctl) ctl.abort();
    ctl = root.AbortController ? new AbortController() : null;
    var artsP = q.length >= 3 ? predictive(q, "article", 10, ctl && ctl.signal).then(function (res) { return res.articles || []; }).catch(function () { return []; }) : Promise.resolve([]);
    var fbMap = function (res) { return (res.products || []).map(function (p) { return { h: p.handle, t: p.title, u: p.url, i: p.featured_image && p.featured_image.url, p: Math.round(parseFloat(p.price_min || p.price || 0) * 100) }; }); };
    loadIndex().then(function (eng) {
      var r = eng.search(q, { live: true });
      return artsP.then(function (arts) {
        if (my !== seq) return;
        arts = arts.filter(function (a) { return eng.textMatch(a.title, r ? r.words : []); });
        if (r && !r.hits.length && q.length >= 3) {
          /* no poster holds these words: Shopify's own (semantic) suggestions, said as approximate */
          return predictive(q, "product", 6, ctl && ctl.signal).then(function (res) {
            if (my !== seq) return;
            var fb = fbMap(res); renderWindow(q, r, arts, fb.length ? fb : null);
          }).catch(function () { if (my === seq) renderWindow(q, r, arts, null); });
        }
        renderWindow(q, r, arts, null);
      });
    }).catch(function () {
      /* index unreachable: Shopify predictive search, as before */
      predictive(q, "product,article", 6, ctl && ctl.signal).then(function (res) {
        if (my !== seq) return;
        renderWindow(q, null, res.articles || [], fbMap(res));
      }).catch(function (e) { if ((!e || e.name !== "AbortError") && my === seq) renderWindow(q, null, [], null); });
    });
  }
  function onInput(e) {
    if (!e.target || e.target.id !== "rv-search-in") return;
    /* rv-core.js handles the same input (predictive search + log): this file replaces it, so it stops here */
    e.stopImmediatePropagation();
    /* rv-core's [data-rv-q] click handler also catches the product page quantity buttons (data-rv-q="1"/"-1") and types
       « 1 » in this hidden field: ignore any synthetic input while the window is closed */
    if (!e.isTrusted && ov && ov.hidden) { e.target.value = lastQ; return; }
    var q = e.target.value.trim();
    clearTimeout(timer);
    if (!q) { showIdle(); return; }
    if (q === lastQ) return;
    lastQ = q;
    timer = setTimeout(function () { runWindow(q); }, 120);
    logSearch(q);
  }
  /* OS-5: real searches measured (final text, no personal data), as rv-core.js did; silent without RV.rechercheUrl */
  function logSearch(q) {
    if (!RV.rechercheUrl || !navigator.sendBeacon) return;
    clearTimeout(logTimer);
    if (q.length < 3) return;
    logTimer = setTimeout(function () {
      if (q === logged) return; logged = q;
      navigator.sendBeacon(RV.rechercheUrl, new Blob([JSON.stringify({ q: q, page: location.pathname })], { type: "text/plain" }));
    }, 1500);
  }

  /* ---------- recent searches: on this device only (localStorage), 6 at most, « Effacer » empties them ---------- */
  var RKEY = "rv-recent";
  function recent() { try { var a = JSON.parse(localStorage.getItem(RKEY) || "[]"); return Array.isArray(a) ? a.filter(function (x) { return typeof x === "string"; }) : []; } catch (e) { return []; } }
  function remember(q) {
    q = String(q || "").trim().slice(0, 60); if (q.length < 2) return;
    var a = recent().filter(function (x) { return norm(x) !== norm(q); }); a.unshift(q);
    try { localStorage.setItem(RKEY, JSON.stringify(a.slice(0, 6))); } catch (e) {}
  }
  function fillRecent() {
    var sec = $("[data-rsx-recent]", box), ul = sec && $("[data-rsx-recent-list]", sec); if (!ul) return;
    var a = recent();
    ul.innerHTML = a.map(function (x) { return '<li><button type="button" data-rsx-q="' + esc(x) + '">' + esc(x) + "</button></li>"; }).join("");
    sec.hidden = !a.length;
  }

  if (input && box) {
    root.addEventListener("input", onInput, true);
    /* warm the index as soon as the visitor goes for the search */
    var warm = function () { loadIndex().catch(function () {}); };
    doc.addEventListener("rv:overlay-open", function (e) {
      if (e.detail !== "rv-search") return;
      warm();
      if (!input.value.trim()) showIdle();
    });
    doc.addEventListener("focusin", function (e) { if (e.target && e.target.closest && e.target.closest("[data-rv-hsearch]")) warm(); });
    /* the window's form: posters only (the old type=product,article,page counted articles in « N résultats ») */
    var f = input.form; if (f) { var ty = f.querySelector('input[name="type"]'); if (ty) ty.value = "product"; f.addEventListener("submit", function () { remember(input.value); }); }
    /* the magnifier of the phone header: opened here, at the very start of the click. Once the cookies are accepted, Google Tag
       Manager's link-click listener cancels the click on the document and follows the link itself (/search), after rv-core.js
       has already opened the window: the page left under the visitor's finger (bug seen on fr and de, 21/10). */
    root.addEventListener("click", function (e) {
      var o = e.target.closest && e.target.closest('[data-rv-open="search"]');
      if (!o || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault(); e.stopPropagation();
      if (RV.openOverlay) RV.openOverlay("rv-search");
      input.focus();
    }, true);
    box.addEventListener("click", function (e) {
      var b = e.target.closest("[data-rsx-q]");
      if (b) { e.preventDefault(); input.value = b.getAttribute("data-rsx-q"); input.dispatchEvent(new Event("input", { bubbles: true })); input.focus(); return; }
      if (e.target.closest("[data-rsx-clear]")) { e.preventDefault(); try { localStorage.removeItem(RKEY); } catch (x) {} fillRecent(); input.focus(); return; }
      if (e.target.closest("a[href]") && input.value.trim()) remember(input.value);
    });
    if (mfoot) mfoot.addEventListener("click", function (e) { if (e.target.closest("a[href]")) remember(input.value); });
    /* keyboard: down / up go through the suggestions, collections and posters, Enter opens (native link), Esc closes (rv-core).
       Typing a letter on a result goes back to the field. Nothing changes for mouse and touch. */
    ov.addEventListener("keydown", function (e) {
      if (e.key !== "ArrowDown" && e.key !== "ArrowUp") {
        if (e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey && box.contains(doc.activeElement)) input.focus();
        return;
      }
      var items = $$("a[href], button", box).filter(function (x) { return x.offsetParent !== null; });
      if (!items.length) return;
      var i = items.indexOf(doc.activeElement);
      if (doc.activeElement === input) { if (e.key === "ArrowUp") return; i = -1; }
      else if (i < 0) return;
      e.preventDefault();
      var n = e.key === "ArrowDown" ? i + 1 : i - 1;
      if (n < 0) { input.focus(); return; }
      items[Math.min(n, items.length - 1)].focus();
    });
  }
  /* tabs (both places): click, arrows */
  doc.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-rvs-tab]"); if (!b) return;
    e.preventDefault(); showTab(b.closest("[data-rvs-scope]"), b.getAttribute("data-rvs-tab"), true);
  });
  doc.addEventListener("keydown", function (e) {
    var b = e.target.closest && e.target.closest("[data-rvs-tab]"); if (!b || (e.key !== "ArrowRight" && e.key !== "ArrowLeft")) return;
    var all = $$("[data-rvs-tab]", b.parentNode), i = all.indexOf(b) + (e.key === "ArrowRight" ? 1 : -1);
    var n = all[(i + all.length) % all.length]; e.preventDefault(); showTab(b.closest("[data-rvs-scope]"), n.getAttribute("data-rvs-tab"), true); n.focus();
  });
  function showTab(scope, k, user) {
    if (!scope) return;
    $$("[data-rvs-tab]", scope).forEach(function (b) { var on = b.getAttribute("data-rvs-tab") === k; b.setAttribute("aria-selected", String(on)); if (on) b.removeAttribute("tabindex"); else b.setAttribute("tabindex", "-1"); b.classList.toggle("on", on); });
    $$("[role=tabpanel]", scope).forEach(function (p) { p.hidden = p.id.slice(-1) !== k; });
    scope.setAttribute("data-cur", k);
    if (scope.hasAttribute("data-rvs-page") && history.replaceState) { var u = new URL(location.href); u.searchParams.set("scope", k); history.replaceState(null, "", u.pathname + u.search); }
  }

  /* ======================= Results page /search ======================= */
  var page = $("[data-rv-search-page]");
  if (!page) return;
  var PQ = page.getAttribute("data-q") || "", grid = $("[data-rv-grid]", page), scope = $("[data-rvs-page]", page);
  if (!PQ || !scope) return;
  var STEP = 20, order = [], shown = 0, more = $("[data-rvs-more]", page), countEl = $("[data-rvs-count]", page);
  /* cards: the theme's real card (snippets/rv-card-product) rendered by sections/rv-search-cards for up to 20 handles */
  function cards(list) {
    var u = searchUrl + "?type=page&section_id=rv-search-cards&q=" + encodeURIComponent(list.map(function (p) { return p.h; }).join(" "));
    return fetch(u).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (h) {
      var d = doc.createElement("div"); d.innerHTML = h;
      var got = {}; $$(".wallcard[data-handle]", d).forEach(function (c) { got[c.getAttribute("data-handle")] = c; });
      return list.map(function (p) { return got[p.h]; }).filter(Boolean);
    });
  }
  /* « La collection d'abord » on the page: the collection first, its wall photos, a button to its page (filters, sort), nearby collections */
  function heroHtml(r, d) {
    var c = r.feat, ph = d ? (d.i ? [d.i] : []).concat((d.w || []).filter(function (u) { return u !== d.i; })).slice(0, 3) : [];
    return '<div class="rvs-hero-tx"><span class="script">' + T("you_search", { q: esc(PQ) }) + "</span>" +
      '<h2 class="rvs-hero-t">' + T("feat_title", { name: esc(c.t) }) + "</h2>" +
      (d && d.d ? '<p class="rvs-hero-d">' + esc(plain(d.d)) + "</p>" : "") +
      '<p class="rvs-hero-cta"><a class="btn btn-main" href="' + esc(c.u) + '">' + T("feat_cta_n", { count: esc(plural(c.size, "affiche")) }) + "</a>" +
      (r.featP ? "<span>" + T("from_price", { price: esc(money(r.featP)) }) + "</span>" : "") + "</p>" + nearChips(r, 4) + "</div>" +
      (ph.length ? '<a class="rvs-hero-ph rvs-ph' + ph.length + '" href="' + esc(c.u) + '" tabindex="-1" aria-hidden="true">' + ph.map(function (u) {
        return '<img src="' + esc(u) + '" alt="" width="520" height="520">';
      }).join("") + "</a>" : "");
  }
  function nearHead(r) { var h = doc.createElement("h2"); h.className = "rvs-near-h"; h.setAttribute("data-rvs-near-h", ""); h.innerHTML = nearTitle(r); return h; }
  function nextCards(reset) {
    var list = order.slice(shown, shown + STEP); if (!list.length) return Promise.resolve();
    if (more) more.setAttribute("aria-busy", "true");
    grid.setAttribute("aria-busy", "true");
    return cards(list).then(function (els) {
      if (reset) grid.innerHTML = "";
      els.forEach(function (el, i) {
        if (list[i].near && !$("[data-rvs-near-h]", grid)) grid.appendChild(nearHead(lastPageR));
        el.classList.add("rv-up", "in"); /* swap of already-visible results, not a scroll reveal: skip the fade-in */
        grid.appendChild(el);
      });
      shown += list.length;
      grid.removeAttribute("aria-busy");
      if (RV.refreshSel) RV.refreshSel();
      if (more) { more.removeAttribute("aria-busy"); more.hidden = shown >= order.length; }
    });
  }
  var lastPageR = null;
  var arts = $$(".postcard", page), artTab = page.getAttribute("data-tab") === "article";
  loadIndex().then(function (eng) {
    var r = eng.search(PQ, {}); lastPageR = r;
    var hits = r ? r.hits.map(function (h) { return h.p; }) : [], near = r ? r.near.map(function (h) { var p = Object.create(h.p); p.near = 1; return p; }) : [];
    var np = hits.length + near.length;
    var colBox = $("[data-rvs-cols]", page), artBox = $("[data-rvs-arts]", page), ban = $("[data-rvs-banner]", page);
    if (ban && r) { ban.innerHTML = banner(r, !!(r.feat && np)); ban.hidden = !ban.innerHTML; }
    var hero = $("[data-rvs-hero]", page);
    if (hero && r && r.feat && np && !artTab) featData(r.feat).then(function (d) { hero.innerHTML = heroHtml(r, d); hero.hidden = false; page.classList.add("rvs-has-hero"); });
    if (colBox && r) colBox.innerHTML = colList(r.cols, r.words);
    $$("[data-rvs-nc]", page).forEach(function (s) { s.textContent = r ? r.cols.length : 0; });
    /* articles (server results of type=article, semantic too): keep the ones that hold the words */
    if (artTab && r && arts.length) {
      var keep = arts.filter(function (a) { var t = a.querySelector("h3"); return t && eng.textMatch(t.textContent, r.words); });
      if (keep.length) arts.forEach(function (a) { a.hidden = keep.indexOf(a) < 0; });
    }
    if (artBox && !artTab) predictive(PQ, "article", 10).then(function (res) {
      var a = (res.articles || []).filter(function (x) { return eng.textMatch(x.title, r ? r.words : []); });
      artBox.innerHTML = artList(a, r ? r.words : []);
      $$("[data-rvs-na]", page).forEach(function (s) { s.textContent = a.length; });
    }).catch(function () {});
    if (artTab || !grid || !np) {
      /* no poster holds the words: Shopify's results stay, said as approximate */
      if (!artTab && grid && grid.children.length && countEl) countEl.textContent = T("approx", { q: PQ });
      return;
    }
    $$("[data-rvs-np]", page).forEach(function (s) { s.textContent = np; });
    /* Shopify found nothing but the index did (e.g. a typo it does not forgive): the empty grid replaces the zero state */
    if (grid.hidden) { grid.hidden = false; var z = $("[data-rvs-zero]", page); if (z) z.hidden = true; }
    order = hits.concat(near);
    if (countEl) countEl.textContent = near.length ? T("count_near", { count: plural(hits.length, "affiche"), near: near.length }) : T("count", { count: plural(hits.length, "affiche") });
    var pag = $(".rv-pages", page); if (pag) pag.hidden = true;
    grid.setAttribute("aria-busy", "true");
    return nextCards(true).catch(function () { grid.removeAttribute("aria-busy"); if (pag) pag.hidden = false; });
  }).catch(function () {});
  if (more) more.addEventListener("click", function (e) { e.preventDefault(); nextCards(); });
  var sp = new URLSearchParams(location.search).get("scope");
  if (sp && /^[pca]$/.test(sp)) showTab(scope, sp);
})(typeof window !== "undefined" ? window : this);
